// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file chat/chat_event_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import { file_common_common_model } from '../common/common_model_pb';
import { file_message_message_model } from '../message/message_model_pb';
import { file_user_user_model } from '../user/user_model_pb';
import type { Chat_Role, SecretChatAccessRequest_Status } from './chat_model_pb';
import { file_chat_chat_model } from './chat_model_pb';

/**
 * Describes the file chat/chat_event_model.proto.
 */
export const file_chat_chat_event_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChtjaGF0L2NoYXRfZXZlbnRfbW9kZWwucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0ImwKCUNoYXRFdmVudBIKCgJpZBgBIAEoAxIOCgZjaGF0SWQYAiABKAMSCgoCdHMYAyABKAMSNwoHcGF5bG9hZBgEIAEoCzImLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNoYXRFdmVudFBheWxvYWQingwKEENoYXRFdmVudFBheWxvYWQSSgoOZGVsZXRlTWVzc2FnZXMYASABKAsyMC5jb20uZ2VtLmJmZi5jb250cmFjdC5EZWxldGVNZXNzYWdlc0V2ZW50UGF5bG9hZEgAEkgKDXVwZGF0ZU1lc3NhZ2UYAiABKAsyLy5jb20uZ2VtLmJmZi5jb250cmFjdC5VcGRhdGVNZXNzYWdlRXZlbnRQYXlsb2FkSAASRAoLY2hhdENoYW5nZWQYAyABKAsyLS5jb20uZ2VtLmJmZi5jb250cmFjdC5DaGF0Q2hhbmdlZEV2ZW50UGF5bG9hZEgAEk4KEGNsZWFyQ2hhdEhpc3RvcnkYBCABKAsyMi5jb20uZ2VtLmJmZi5jb250cmFjdC5DbGVhckNoYXRIaXN0b3J5RXZlbnRQYXlsb2FkSAASagokZ3JvdXBQYXJ0aWNpcGFudHNDaGFuZ2VkRXZlbnRQYXlsb2FkGAUgASgLMjouY29tLmdlbS5iZmYuY29udHJhY3QuR3JvdXBQYXJ0aWNpcGFudHNDaGFuZ2VkRXZlbnRQYXlsb2FkSAASVQoWY2hhdE1lc3NhZ2VzVHRsQ2hhbmdlZBgGIAEoCzIzLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNoYXRNZXNzYWdlc1R0bENoYW5nZWRQYXlsb2FkSAASUgoSdXNlckNoYXRXYXNEZWxldGVkGGUgASgLMjQuY29tLmdlbS5iZmYuY29udHJhY3QuVXNlckNoYXRXYXNEZWxldGVkRXZlbnRQYXlsb2FkSAASRAoLdXNlclBpbkNoYXQYZiABKAsyLS5jb20uZ2VtLmJmZi5jb250cmFjdC5Vc2VyUGluQ2hhdEV2ZW50UGF5bG9hZEgAEkoKDnVzZXJXYXNSZW1vdmVkGGcgASgLMjAuY29tLmdlbS5iZmYuY29udHJhY3QuVXNlcldhc1JlbW92ZWRFdmVudFBheWxvYWRIABJGCgx1c2VyTGVmdENoYXQYaCABKAsyLi5jb20uZ2VtLmJmZi5jb250cmFjdC5Vc2VyTGVmdENoYXRFdmVudFBheWxvYWRIABJYChV1c2VyQ2hhdHNSb2xlc0NoYW5nZWQYaSABKAsyNy5jb20uZ2VtLmJmZi5jb250cmFjdC5Vc2VyQ2hhdHNSb2xlc0NoYW5nZWRFdmVudFBheWxvYWRIABJMCg91c2VyQ2hhdENoYW5nZWQYaiABKAsyMS5jb20uZ2VtLmJmZi5jb250cmFjdC5Vc2VyQ2hhdENoYW5nZWRFdmVudFBheWxvYWRIABJWChR1c2VyQ2xlYXJDaGF0SGlzdG9yeRhrIAEoCzI2LmNvbS5nZW0uYmZmLmNvbnRyYWN0LlVzZXJDbGVhckNoYXRIaXN0b3J5RXZlbnRQYXlsb2FkSAASXAoXdXNlclN0aWNrZXJQYWNrc1VwZGF0ZWQYbCABKAsyOS5jb20uZ2VtLmJmZi5jb250cmFjdC5Vc2VyU3RpY2tlclBhY2tzVXBkYXRlZEV2ZW50UGF5bG9hZEgAEk0KEmNoYXRNYXJrZWRBc1VucmVhZBhtIAEoCzIvLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNoYXRNYXJrZWRBc1VucmVhZFBheWxvYWRIABJfCht1c2VyU2NoZWR1bGVkTWVzc2FnZVVwZGF0ZWQYbyABKAsyOC5jb20uZ2VtLmJmZi5jb250cmFjdC5Vc2VyU2NoZWR1bGVkTWVzc2FnZVVwZGF0ZWRQYXlsb2FkSAASXwobdXNlclNjaGVkdWxlZE1lc3NhZ2VEZWxldGVkGHAgASgLMjguY29tLmdlbS5iZmYuY29udHJhY3QuVXNlclNjaGVkdWxlZE1lc3NhZ2VEZWxldGVkUGF5bG9hZEgAEmMKHXNlY3JldENoYXRBY2Nlc3NSZXF1ZXN0VXBkYXRlGHEgASgLMjouY29tLmdlbS5iZmYuY29udHJhY3QuU2VjcmV0Q2hhdEFjY2Vzc1JlcXVlc3RVcGRhdGVQYXlsb2FkSABCBgoEdHlwZUoECG4Qb0oECAcQZUoFCHIQyQEiQAoaRGVsZXRlTWVzc2FnZXNFdmVudFBheWxvYWQSDgoGY2hhdElkGAEgASgDEhIKCm1lc3NhZ2VJZHMYAiADKAMiGQoXQ2hhdENoYW5nZWRFdmVudFBheWxvYWQiXAobVXNlckNoYXRDaGFuZ2VkRXZlbnRQYXlsb2FkEj0KCWV2ZW50RGF0YRgBIAEoCzIqLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNoYXRVcGRhdGVkRXZlbnREYXRhImEKIFVzZXJDbGVhckNoYXRIaXN0b3J5RXZlbnRQYXlsb2FkEj0KCWV2ZW50RGF0YRgBIAEoCzIqLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNoYXRVcGRhdGVkRXZlbnREYXRhIh4KHENsZWFyQ2hhdEhpc3RvcnlFdmVudFBheWxvYWQiSgokR3JvdXBQYXJ0aWNpcGFudHNDaGFuZ2VkRXZlbnRQYXlsb2FkEg4KBmNoYXRJZBgBIAEoAxISCgp1c2Vyc0NvdW50GAIgASgDIlkKGFVzZXJMZWZ0Q2hhdEV2ZW50UGF5bG9hZBI9CglldmVudERhdGEYASABKAsyKi5jb20uZ2VtLmJmZi5jb250cmFjdC5DaGF0VXBkYXRlZEV2ZW50RGF0YSJfCh5Vc2VyQ2hhdFdhc0RlbGV0ZWRFdmVudFBheWxvYWQSPQoJZXZlbnREYXRhGAEgASgLMiouY29tLmdlbS5iZmYuY29udHJhY3QuQ2hhdFVwZGF0ZWRFdmVudERhdGEiWwoaVXNlcldhc1JlbW92ZWRFdmVudFBheWxvYWQSPQoJZXZlbnREYXRhGAEgASgLMiouY29tLmdlbS5iZmYuY29udHJhY3QuQ2hhdFVwZGF0ZWRFdmVudERhdGEiJgoUQ2hhdFVwZGF0ZWRFdmVudERhdGESDgoGY2hhdElkGAEgASgDIioKF1VzZXJQaW5DaGF0RXZlbnRQYXlsb2FkEg8KB2NoYXRJZHMYASADKAMijwIKIVVzZXJDaGF0c1JvbGVzQ2hhbmdlZEV2ZW50UGF5bG9hZBJiChFjaGF0c1JvbGVzQ2hhbmdlcxgBIAMoCzJHLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlVzZXJDaGF0c1JvbGVzQ2hhbmdlZEV2ZW50UGF5bG9hZC5DaGF0Um9sZUNoYW5nZXMahQEKD0NoYXRSb2xlQ2hhbmdlcxIOCgZjaGF0SWQYASABKAMSMAoHb2xkUm9sZRgCIAEoDjIfLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkNoYXQuUm9sZRIwCgduZXdSb2xlGAMgASgOMh8uY29tLmdlbS5iZmYuY29udHJhY3QuQ2hhdC5Sb2xlIj4KGVVwZGF0ZU1lc3NhZ2VFdmVudFBheWxvYWQSDgoGY2hhdElkGAEgASgDEhEKCW1lc3NhZ2VJZBgCIAEoAyI7CiNVc2VyU3RpY2tlclBhY2tzVXBkYXRlZEV2ZW50UGF5bG9hZBIUCgxzdGlja2VyUGFja3MYASADKAMiOwoZQ2hhdE1hcmtlZEFzVW5yZWFkUGF5bG9hZBIOCgZjaGF0SWQYASABKAMSDgoGdW5yZWFkGAIgASgIImcKIlVzZXJTY2hlZHVsZWRNZXNzYWdlVXBkYXRlZFBheWxvYWQSDgoGY2hhdElkGAEgASgDEhEKCW1lc3NhZ2VJZBgCIAEoAxITCgZzdGF0dXMYAyABKAlIAIgBAUIJCgdfc3RhdHVzIkcKIlVzZXJTY2hlZHVsZWRNZXNzYWdlRGVsZXRlZFBheWxvYWQSDgoGY2hhdElkGAEgASgDEhEKCW1lc3NhZ2VJZBgCIAEoAyJDCh1DaGF0TWVzc2FnZXNUdGxDaGFuZ2VkUGF5bG9hZBIVCghwZXJpb2RNcxgBIAEoA0gAiAEBQgsKCV9wZXJpb2RNcyKrAQokU2VjcmV0Q2hhdEFjY2Vzc1JlcXVlc3RVcGRhdGVQYXlsb2FkEg4KBnVzZXJJZBgBIAEoAxIQCghkZXZpY2VJZBgCIAEoCRJECgZzdGF0dXMYAyABKA4yNC5jb20uZ2VtLmJmZi5jb250cmFjdC5TZWNyZXRDaGF0QWNjZXNzUmVxdWVzdC5TdGF0dXMSGwoTYWN0aXZlUmVxdWVzdHNDb3VudBgEIAEoBUIYChRjb20uZ2VtLmJmZi5jb250cmFjdFABYgZwcm90bzM',
    [
      file_message_message_model,
      file_common_common_model,
      file_user_user_model,
      file_chat_chat_model,
    ]
  );

/**
 * @generated from message com.gem.bff.contract.ChatEvent
 */
export type ChatEvent = Message<'com.gem.bff.contract.ChatEvent'> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 chatId = 2;
   */
  chatId: bigint;

  /**
   * @generated from field: int64 ts = 3;
   */
  ts: bigint;

  /**
   * @generated from field: com.gem.bff.contract.ChatEventPayload payload = 4;
   */
  payload?: ChatEventPayload;
};

/**
 * Describes the message com.gem.bff.contract.ChatEvent.
 * Use `create(ChatEventSchema)` to create a new message.
 */
export const ChatEventSchema: GenMessage<ChatEvent> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 0);

/**
 * @generated from message com.gem.bff.contract.ChatEventPayload
 */
export type ChatEventPayload = Message<'com.gem.bff.contract.ChatEventPayload'> & {
  /**
   * @generated from oneof com.gem.bff.contract.ChatEventPayload.type
   */
  type:
    | {
        /**
         *  0-100 - chat events
         *
         * @generated from field: com.gem.bff.contract.DeleteMessagesEventPayload deleteMessages = 1;
         */
        value: DeleteMessagesEventPayload;
        case: 'deleteMessages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UpdateMessageEventPayload updateMessage = 2;
         */
        value: UpdateMessageEventPayload;
        case: 'updateMessage';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatChangedEventPayload chatChanged = 3;
         */
        value: ChatChangedEventPayload;
        case: 'chatChanged';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ClearChatHistoryEventPayload clearChatHistory = 4;
         */
        value: ClearChatHistoryEventPayload;
        case: 'clearChatHistory';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GroupParticipantsChangedEventPayload groupParticipantsChangedEventPayload = 5;
         */
        value: GroupParticipantsChangedEventPayload;
        case: 'groupParticipantsChangedEventPayload';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatMessagesTtlChangedPayload chatMessagesTtlChanged = 6;
         */
        value: ChatMessagesTtlChangedPayload;
        case: 'chatMessagesTtlChanged';
      }
    | {
        /**
         *  101-200 - user personal events
         *
         * @generated from field: com.gem.bff.contract.UserChatWasDeletedEventPayload userChatWasDeleted = 101;
         */
        value: UserChatWasDeletedEventPayload;
        case: 'userChatWasDeleted';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserPinChatEventPayload userPinChat = 102;
         */
        value: UserPinChatEventPayload;
        case: 'userPinChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserWasRemovedEventPayload userWasRemoved = 103;
         */
        value: UserWasRemovedEventPayload;
        case: 'userWasRemoved';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserLeftChatEventPayload userLeftChat = 104;
         */
        value: UserLeftChatEventPayload;
        case: 'userLeftChat';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserChatsRolesChangedEventPayload userChatsRolesChanged = 105;
         */
        value: UserChatsRolesChangedEventPayload;
        case: 'userChatsRolesChanged';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserChatChangedEventPayload userChatChanged = 106;
         */
        value: UserChatChangedEventPayload;
        case: 'userChatChanged';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserClearChatHistoryEventPayload userClearChatHistory = 107;
         */
        value: UserClearChatHistoryEventPayload;
        case: 'userClearChatHistory';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserStickerPacksUpdatedEventPayload userStickerPacksUpdated = 108;
         */
        value: UserStickerPacksUpdatedEventPayload;
        case: 'userStickerPacksUpdated';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.ChatMarkedAsUnreadPayload chatMarkedAsUnread = 109;
         */
        value: ChatMarkedAsUnreadPayload;
        case: 'chatMarkedAsUnread';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserScheduledMessageUpdatedPayload userScheduledMessageUpdated = 111;
         */
        value: UserScheduledMessageUpdatedPayload;
        case: 'userScheduledMessageUpdated';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UserScheduledMessageDeletedPayload userScheduledMessageDeleted = 112;
         */
        value: UserScheduledMessageDeletedPayload;
        case: 'userScheduledMessageDeleted';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.SecretChatAccessRequestUpdatePayload secretChatAccessRequestUpdate = 113;
         */
        value: SecretChatAccessRequestUpdatePayload;
        case: 'secretChatAccessRequestUpdate';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.ChatEventPayload.
 * Use `create(ChatEventPayloadSchema)` to create a new message.
 */
export const ChatEventPayloadSchema: GenMessage<ChatEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 1);

/**
 * This payload is associated with the following event types: messages.were.deleted
 *
 * @generated from message com.gem.bff.contract.DeleteMessagesEventPayload
 */
export type DeleteMessagesEventPayload =
  Message<'com.gem.bff.contract.DeleteMessagesEventPayload'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: repeated int64 messageIds = 2;
     */
    messageIds: bigint[];
  };

/**
 * Describes the message com.gem.bff.contract.DeleteMessagesEventPayload.
 * Use `create(DeleteMessagesEventPayloadSchema)` to create a new message.
 */
export const DeleteMessagesEventPayloadSchema: GenMessage<DeleteMessagesEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 2);

/**
 * This payload is associated with the following event types: group
 *
 * @generated from message com.gem.bff.contract.ChatChangedEventPayload
 */
export type ChatChangedEventPayload = Message<'com.gem.bff.contract.ChatChangedEventPayload'> & {};

/**
 * Describes the message com.gem.bff.contract.ChatChangedEventPayload.
 * Use `create(ChatChangedEventPayloadSchema)` to create a new message.
 */
export const ChatChangedEventPayloadSchema: GenMessage<ChatChangedEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 3);

/**
 * This payload is associated with the following event types: group.changed
 *
 * @generated from message com.gem.bff.contract.UserChatChangedEventPayload
 */
export type UserChatChangedEventPayload =
  Message<'com.gem.bff.contract.UserChatChangedEventPayload'> & {
    /**
     * @generated from field: com.gem.bff.contract.ChatUpdatedEventData eventData = 1;
     */
    eventData?: ChatUpdatedEventData;
  };

/**
 * Describes the message com.gem.bff.contract.UserChatChangedEventPayload.
 * Use `create(UserChatChangedEventPayloadSchema)` to create a new message.
 */
export const UserChatChangedEventPayloadSchema: GenMessage<UserChatChangedEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 4);

/**
 * This payload is associated with the following event types: clear.history
 *
 * @generated from message com.gem.bff.contract.UserClearChatHistoryEventPayload
 */
export type UserClearChatHistoryEventPayload =
  Message<'com.gem.bff.contract.UserClearChatHistoryEventPayload'> & {
    /**
     * @generated from field: com.gem.bff.contract.ChatUpdatedEventData eventData = 1;
     */
    eventData?: ChatUpdatedEventData;
  };

/**
 * Describes the message com.gem.bff.contract.UserClearChatHistoryEventPayload.
 * Use `create(UserClearChatHistoryEventPayloadSchema)` to create a new message.
 */
export const UserClearChatHistoryEventPayloadSchema: GenMessage<UserClearChatHistoryEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 5);

/**
 * This payload is associated with the following event types: clear.history.for.all
 *
 * @generated from message com.gem.bff.contract.ClearChatHistoryEventPayload
 */
export type ClearChatHistoryEventPayload =
  Message<'com.gem.bff.contract.ClearChatHistoryEventPayload'> & {};

/**
 * Describes the message com.gem.bff.contract.ClearChatHistoryEventPayload.
 * Use `create(ClearChatHistoryEventPayloadSchema)` to create a new message.
 */
export const ClearChatHistoryEventPayloadSchema: GenMessage<ClearChatHistoryEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 6);

/**
 * This payload is associated with the following event types: group.participants.changed
 *
 * @generated from message com.gem.bff.contract.GroupParticipantsChangedEventPayload
 */
export type GroupParticipantsChangedEventPayload =
  Message<'com.gem.bff.contract.GroupParticipantsChangedEventPayload'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 usersCount = 2;
     */
    usersCount: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.GroupParticipantsChangedEventPayload.
 * Use `create(GroupParticipantsChangedEventPayloadSchema)` to create a new message.
 */
export const GroupParticipantsChangedEventPayloadSchema: GenMessage<GroupParticipantsChangedEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 7);

/**
 * This payload is associated with the following event types: group.self.leave
 *
 * @generated from message com.gem.bff.contract.UserLeftChatEventPayload
 */
export type UserLeftChatEventPayload = Message<'com.gem.bff.contract.UserLeftChatEventPayload'> & {
  /**
   * @generated from field: com.gem.bff.contract.ChatUpdatedEventData eventData = 1;
   */
  eventData?: ChatUpdatedEventData;
};

/**
 * Describes the message com.gem.bff.contract.UserLeftChatEventPayload.
 * Use `create(UserLeftChatEventPayloadSchema)` to create a new message.
 */
export const UserLeftChatEventPayloadSchema: GenMessage<UserLeftChatEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 8);

/**
 * This payload is associated with the following event types: group.was.deleted
 *
 * @generated from message com.gem.bff.contract.UserChatWasDeletedEventPayload
 */
export type UserChatWasDeletedEventPayload =
  Message<'com.gem.bff.contract.UserChatWasDeletedEventPayload'> & {
    /**
     * @generated from field: com.gem.bff.contract.ChatUpdatedEventData eventData = 1;
     */
    eventData?: ChatUpdatedEventData;
  };

/**
 * Describes the message com.gem.bff.contract.UserChatWasDeletedEventPayload.
 * Use `create(UserChatWasDeletedEventPayloadSchema)` to create a new message.
 */
export const UserChatWasDeletedEventPayloadSchema: GenMessage<UserChatWasDeletedEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 9);

/**
 * This payload is associated with the following event types: user.was.removed
 *
 * @generated from message com.gem.bff.contract.UserWasRemovedEventPayload
 */
export type UserWasRemovedEventPayload =
  Message<'com.gem.bff.contract.UserWasRemovedEventPayload'> & {
    /**
     * @generated from field: com.gem.bff.contract.ChatUpdatedEventData eventData = 1;
     */
    eventData?: ChatUpdatedEventData;
  };

/**
 * Describes the message com.gem.bff.contract.UserWasRemovedEventPayload.
 * Use `create(UserWasRemovedEventPayloadSchema)` to create a new message.
 */
export const UserWasRemovedEventPayloadSchema: GenMessage<UserWasRemovedEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 10);

/**
 * @generated from message com.gem.bff.contract.ChatUpdatedEventData
 */
export type ChatUpdatedEventData = Message<'com.gem.bff.contract.ChatUpdatedEventData'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.ChatUpdatedEventData.
 * Use `create(ChatUpdatedEventDataSchema)` to create a new message.
 */
export const ChatUpdatedEventDataSchema: GenMessage<ChatUpdatedEventData> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 11);

/**
 * This payload is associated with the following event types: config.group.pin
 *
 * @generated from message com.gem.bff.contract.UserPinChatEventPayload
 */
export type UserPinChatEventPayload = Message<'com.gem.bff.contract.UserPinChatEventPayload'> & {
  /**
   * @generated from field: repeated int64 chatIds = 1;
   */
  chatIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.UserPinChatEventPayload.
 * Use `create(UserPinChatEventPayloadSchema)` to create a new message.
 */
export const UserPinChatEventPayloadSchema: GenMessage<UserPinChatEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 12);

/**
 * This payload is associated with the following event types: roles.were.changed
 *
 * @generated from message com.gem.bff.contract.UserChatsRolesChangedEventPayload
 */
export type UserChatsRolesChangedEventPayload =
  Message<'com.gem.bff.contract.UserChatsRolesChangedEventPayload'> & {
    /**
     * @generated from field: repeated com.gem.bff.contract.UserChatsRolesChangedEventPayload.ChatRoleChanges chatsRolesChanges = 1;
     */
    chatsRolesChanges: UserChatsRolesChangedEventPayload_ChatRoleChanges[];
  };

/**
 * Describes the message com.gem.bff.contract.UserChatsRolesChangedEventPayload.
 * Use `create(UserChatsRolesChangedEventPayloadSchema)` to create a new message.
 */
export const UserChatsRolesChangedEventPayloadSchema: GenMessage<UserChatsRolesChangedEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 13);

/**
 * @generated from message com.gem.bff.contract.UserChatsRolesChangedEventPayload.ChatRoleChanges
 */
export type UserChatsRolesChangedEventPayload_ChatRoleChanges =
  Message<'com.gem.bff.contract.UserChatsRolesChangedEventPayload.ChatRoleChanges'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: com.gem.bff.contract.Chat.Role oldRole = 2;
     */
    oldRole: Chat_Role;

    /**
     * @generated from field: com.gem.bff.contract.Chat.Role newRole = 3;
     */
    newRole: Chat_Role;
  };

/**
 * Describes the message com.gem.bff.contract.UserChatsRolesChangedEventPayload.ChatRoleChanges.
 * Use `create(UserChatsRolesChangedEventPayload_ChatRoleChangesSchema)` to create a new message.
 */
export const UserChatsRolesChangedEventPayload_ChatRoleChangesSchema: GenMessage<UserChatsRolesChangedEventPayload_ChatRoleChanges> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 13, 0);

/**
 * This payload is associated with the following event types: message.was.updated
 *
 * @generated from message com.gem.bff.contract.UpdateMessageEventPayload
 */
export type UpdateMessageEventPayload =
  Message<'com.gem.bff.contract.UpdateMessageEventPayload'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 messageId = 2;
     */
    messageId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.UpdateMessageEventPayload.
 * Use `create(UpdateMessageEventPayloadSchema)` to create a new message.
 */
export const UpdateMessageEventPayloadSchema: GenMessage<UpdateMessageEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 14);

/**
 * This payload is associated with the following event types: user.sticker.packs.updated
 *
 * @generated from message com.gem.bff.contract.UserStickerPacksUpdatedEventPayload
 */
export type UserStickerPacksUpdatedEventPayload =
  Message<'com.gem.bff.contract.UserStickerPacksUpdatedEventPayload'> & {
    /**
     * @generated from field: repeated int64 stickerPacks = 1;
     */
    stickerPacks: bigint[];
  };

/**
 * Describes the message com.gem.bff.contract.UserStickerPacksUpdatedEventPayload.
 * Use `create(UserStickerPacksUpdatedEventPayloadSchema)` to create a new message.
 */
export const UserStickerPacksUpdatedEventPayloadSchema: GenMessage<UserStickerPacksUpdatedEventPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 15);

/**
 * @generated from message com.gem.bff.contract.ChatMarkedAsUnreadPayload
 */
export type ChatMarkedAsUnreadPayload =
  Message<'com.gem.bff.contract.ChatMarkedAsUnreadPayload'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: bool unread = 2;
     */
    unread: boolean;
  };

/**
 * Describes the message com.gem.bff.contract.ChatMarkedAsUnreadPayload.
 * Use `create(ChatMarkedAsUnreadPayloadSchema)` to create a new message.
 */
export const ChatMarkedAsUnreadPayloadSchema: GenMessage<ChatMarkedAsUnreadPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 16);

/**
 * @generated from message com.gem.bff.contract.UserScheduledMessageUpdatedPayload
 */
export type UserScheduledMessageUpdatedPayload =
  Message<'com.gem.bff.contract.UserScheduledMessageUpdatedPayload'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 messageId = 2;
     */
    messageId: bigint;

    /**
     * @generated from field: optional string status = 3;
     */
    status?: string;
  };

/**
 * Describes the message com.gem.bff.contract.UserScheduledMessageUpdatedPayload.
 * Use `create(UserScheduledMessageUpdatedPayloadSchema)` to create a new message.
 */
export const UserScheduledMessageUpdatedPayloadSchema: GenMessage<UserScheduledMessageUpdatedPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 17);

/**
 * @generated from message com.gem.bff.contract.UserScheduledMessageDeletedPayload
 */
export type UserScheduledMessageDeletedPayload =
  Message<'com.gem.bff.contract.UserScheduledMessageDeletedPayload'> & {
    /**
     * @generated from field: int64 chatId = 1;
     */
    chatId: bigint;

    /**
     * @generated from field: int64 messageId = 2;
     */
    messageId: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.UserScheduledMessageDeletedPayload.
 * Use `create(UserScheduledMessageDeletedPayloadSchema)` to create a new message.
 */
export const UserScheduledMessageDeletedPayloadSchema: GenMessage<UserScheduledMessageDeletedPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 18);

/**
 * @generated from message com.gem.bff.contract.ChatMessagesTtlChangedPayload
 */
export type ChatMessagesTtlChangedPayload =
  Message<'com.gem.bff.contract.ChatMessagesTtlChangedPayload'> & {
    /**
     * @generated from field: optional int64 periodMs = 1;
     */
    periodMs?: bigint;
  };

/**
 * Describes the message com.gem.bff.contract.ChatMessagesTtlChangedPayload.
 * Use `create(ChatMessagesTtlChangedPayloadSchema)` to create a new message.
 */
export const ChatMessagesTtlChangedPayloadSchema: GenMessage<ChatMessagesTtlChangedPayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 19);

/**
 * @generated from message com.gem.bff.contract.SecretChatAccessRequestUpdatePayload
 */
export type SecretChatAccessRequestUpdatePayload =
  Message<'com.gem.bff.contract.SecretChatAccessRequestUpdatePayload'> & {
    /**
     * @generated from field: int64 userId = 1;
     */
    userId: bigint;

    /**
     * @generated from field: string deviceId = 2;
     */
    deviceId: string;

    /**
     * @generated from field: com.gem.bff.contract.SecretChatAccessRequest.Status status = 3;
     */
    status: SecretChatAccessRequest_Status;

    /**
     * @generated from field: int32 activeRequestsCount = 4;
     */
    activeRequestsCount: number;
  };

/**
 * Describes the message com.gem.bff.contract.SecretChatAccessRequestUpdatePayload.
 * Use `create(SecretChatAccessRequestUpdatePayloadSchema)` to create a new message.
 */
export const SecretChatAccessRequestUpdatePayloadSchema: GenMessage<SecretChatAccessRequestUpdatePayload> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_event_model, 20);
